/**
 * Service used to share content to social network
 */
export class YoutubeService {
    /**
     * get youtube id video
     * @param urlVideo : url of video
     */
    static getIDVideo(urlVideo) {
        // regex to extract YT ID video
        const regExpYoutube = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
        const matchYT = urlVideo.match(regExpYoutube);
        if (matchYT && matchYT[7].length == 11) {
            // id youtube video
            return matchYT[7];
        }
        return "";
    }
    /**
     * get youtube id video
     * @param urlVideo : url of video
     */
    static getThumbailVideoUrl(urlVideo) {
        let id = this.getIDVideo(urlVideo);
        if (id) {
            return `https://img.youtube.com/vi/${id}/default.jpg`;
        }
        return "";
    }
    /**
     * get no cookie url video player
     * @param urlVideo : url of video
     * @returns link no coookie video player
     */
    static getNoCookieLink(urlVideo) {
        let urlForVideo = "";
        let id = this.getIDVideo(urlVideo);
        if (id) {
            urlForVideo = `https://www.youtube-nocookie.com/embed/${id}`;
        }
        return urlForVideo;
    }
}
